'use strict';

import { Component, createRef } from 'react';
import moment from 'moment';
import { Link } from 'react-router';

import UserStore from '@stores/UserStore';

import './MembershipExpiredBanner.scss';

export default class MembershipExpiredBanner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: UserStore.getUser(),
        };

        this.bannerRef = createRef();
    }

    componentDidMount = () => {
        UserStore.addChangeListener(this.onUserStoreChange);
        window.addEventListener('resize', this.syncBannerHeight);
        this.syncBannerHeight();
    }

    componentDidUpdate = () => {
        this.syncBannerHeight();
    }

    componentWillUnmount = () => {
        UserStore.removeChangeListener(this.onUserStoreChange);
        window.removeEventListener('resize', this.syncBannerHeight);
        // Reset the offset so the meal-feed toolbar/content return to normal.
        document.documentElement.style.setProperty('--membership-banner-height', '0px');
    }

    onUserStoreChange = () => {
        this.setState({user: UserStore.getUser()});
    }

    // The banner is position:fixed, so it can't push siblings. Publish its rendered
    // height (0 when hidden) as a CSS var; the fixed meal-feed toolbar and the feed
    // content padding add it so they sit below the banner.
    syncBannerHeight = () => {
        const height = this.bannerRef.current ? this.bannerRef.current.offsetHeight : 0;
        document.documentElement.style.setProperty('--membership-banner-height', `${height}px`);
    }

    render() {
        const { user } = this.state;

        if (!user) {
            return <span />;
        }

        // Only self-service consumers can purchase their own membership. Managed
        // (dietitian-owned) consumers and PRO users have this capability disabled.
        if (!(user.capabilities && user.capabilities.purchase_membership)) {
            return <span />;
        }

        if (!user.active_until || !moment(user.active_until).isBefore(moment())) {
            return <span />;
        }

        return (
            <span>
                <div className="membership-expired-banner" ref={this.bannerRef}><div className="banner-container">
                    <h3>Your membership has expired</h3>
                    <p>Purchase a membership to keep building meal plans and viewing recipes.</p>

                    <footer>
                        <Link to="/membership"><button>Renew Membership</button></Link>
                    </footer>
                </div></div>
            </span>
        );
    }
}
